var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenBolt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: 13,
      height: 13,
      display: "block"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.81557 1.36733C9.12392 1.46453 9.33361 1.75049 9.33361 2.0738V5.77747L12.2965 5.77747C12.5728 5.77747 12.826 5.93114 12.9536 6.17613C13.0811 6.42111 13.0618 6.71672 12.9034 6.94299L7.71824 14.3503C7.53283 14.6152 7.19706 14.7292 6.88871 14.632C6.58036 14.5348 6.37067 14.2489 6.37067 13.9256L6.37067 10.2219H3.40773C3.13153 10.2219 2.87827 10.0682 2.75071 9.82322C2.62316 9.57824 2.6425 9.28263 2.8009 9.05636L7.98604 1.64901C8.17144 1.38415 8.50721 1.27013 8.81557 1.36733Z",
    fill: "#5C6930"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBolt);
export default __webpack_public_path__ + "static/media/green-bolt.e18961f8fdba5a29776210c92133a82a.svg";
export { ForwardRef as ReactComponent };